import React from "react";
import { Link } from "react-router-dom";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen">
      <header className="bg-white shadow sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
          <h1 className="text-2xl font-bold text-primary">NextDME</h1>
          <nav className="flex gap-6 text-gray-700">
            <Link to="/" className="hover:text-primary">Home</Link>
            <Link to="/features" className="hover:text-primary">Features</Link>
            <Link to="/about" className="hover:text-primary">About</Link>
            <Link to="/resources" className="hover:text-primary">Resources</Link>
            <Link to="/contact" className="hover:text-primary">Contact</Link>
          </nav>
        </div>
      </header>

      <main className="max-w-6xl mx-auto p-6">{children}</main>

      <footer className="bg-white border-t border-gray-200 mt-10">
        <div className="max-w-6xl mx-auto px-6 py-6 text-sm text-gray-600">
          © {new Date().getFullYear()} NextDME — All rights reserved - 1404 Flightline Drive, Ste B, Lincoln, CA 95648 (916)730-0788
        </div>
      </footer>
    </div>
  );
}